import { graphql } from "@/lib/gql/__generated__";

export const VoucherListUpdate_TopPage_Mutation = graphql(/* GraphQL */ `
	mutation VoucherListUpdate_TopPage($input: VoucherListInput!) {
		voucherListUpdate(input: $input) {
			userErrors
			voucherList {
				id
				voucherList {
					id
					hotelID
					voucherID
					inSale
					name
					description
					mainKeyVisual {
						bucket
						key
						region
						mimeType
						fileName
					}
					voucherPrice {
						currencyType
						amount
					}
					sellingPrice {
						currencyType
						amount
					}
					saleTypeForTerm
					saleStart
					saleEnd
					maxStockNum
					soldNumTotal
					voucherLimitType
					intervalPrepDates
					cinStart
					cinEnd
					deletedAt
				}
			}
		}
	}
`);
